/**
 * Ukuran tampilan (kepadatan) — port MGMX. Preferensi per perangkat, disimpan di localStorage.
 * Diterapkan lewat `html[data-density]` → skala root font-size (lihat globals.css). `null` = otomatis
 * (Ringkas di tablet/HP sentuh, Normal di desktop).
 */
export type Density = "tiny" | "small" | "compact" | "normal" | "comfortable";

/** Urutan dari paling kecil ke paling besar. */
export const DENSITY_ORDER: Density[] = ["tiny", "small", "compact", "normal", "comfortable"];

export const DENSITY_LABEL: Record<Density, string> = {
    tiny: "Sangat ringkas",
    small: "Lebih ringkas",
    compact: "Ringkas",
    normal: "Normal",
    comfortable: "Lega",
};

const STORAGE_KEY = "mgtruck-density";

export function loadDensity(): Density | null {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        return v && (DENSITY_ORDER as string[]).includes(v) ? (v as Density) : null;
    } catch {
        return null;
    }
}

export function saveDensity(d: Density | null) {
    try {
        if (d) localStorage.setItem(STORAGE_KEY, d);
        else localStorage.removeItem(STORAGE_KEY);
    } catch { /* abaikan (mode privat) */ }
}

/** Layar sentuh berukuran tablet/HP (< 1280px). */
export function isTouchSmallScreen(): boolean {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(pointer: coarse)").matches && window.innerWidth < 1280;
}

/** Kepadatan efektif (preferensi user, atau otomatis menurut perangkat). */
export function effectiveDensity(d: Density | null): Density {
    return d ?? (isTouchSmallScreen() ? "compact" : "normal");
}
